if($('.in-index').length){
    if($('.welcome img[style="float: right;"]').length){
        $('.welcome').after($('img[style="float: right;"]').closest('p'))
    }
    $('.overall-wrapper').append('<div class="customProductsBlock container"></div>')
    $('.customProductsBlock').append($('.homepage-products-heading-1'), $('.products-block'))
}